// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './AutoClosable';



// WEBPACK FOOTER //
// ./components/AutoClosable/index.js